/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import moment from 'moment'
import { generateDateWithTime, GenerateDateandTime } from '../../../../redux/helper/DateConverter'
import { CamelCase } from '../../../../redux/helper/CamelCase'

export default function OrderHeader({ orderStatus, OrderData }) {
    const payment_status = {
        0: 'Pending',
        1: 'Partial',
        2: 'Paid',
    };

    const getDispatchDate = () => {
        let leadTimeArray = []
        for (const key in OrderData?.order?.items) {
            for (let index = 0; index < OrderData?.order?.items[key].length; index++) {
                leadTimeArray.push(OrderData?.order?.items[key][index].DELIVERY_LEAD_TIME)
            }
        }
        let result = leadTimeArray[0];
        for (let i = 1; i < leadTimeArray.length; i++)
            if (leadTimeArray[i] != null) {
                result = result > leadTimeArray[i] ? result : leadTimeArray[i];
            }
        if (result == 'A') {
            return moment.unix(parseInt(OrderData?.order?.order_acceptance_date !== null ? OrderData?.order?.order_acceptance_date : OrderData?.order?.created_at)).add(10, 'd').format("DD-MMM-YYYY")
        } else if (result == 'B') {
            return moment.unix(parseInt(OrderData?.order?.order_acceptance_date !== null ? OrderData?.order?.order_acceptance_date : OrderData?.order?.created_at)).add(21, 'd').format("DD-MMM-YYYY")
        } else if (result == 'C')
            return moment.unix(parseInt(OrderData?.order?.order_acceptance_date !== null ? OrderData?.order?.order_acceptance_date : OrderData?.order?.created_at)).add(45, 'd').format("DD-MMM-YYYY")
        else return '-'
    }

    return (
        <>
            <div className="sm:py-2 py-1 sm:px-7 px-2.5 bg-[#F5F5FA] rounded-lg  flex justify-between items-center lg:flex-nowrap flex-wrap">
                <div className="pb-2 mr-2">
                    <p className="text-[#777777] font-semibold text-xs">Indent Number</p>
                    <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{OrderData?.order?.order_number || '-'}</p>
                </div>
                <div className="pb-2 mr-2">
                    <p className="text-[#777777] font-semibold text-xs text-center">Order Status</p>
                    <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{CamelCase(orderStatus[OrderData?.order?.status])}</p>
                </div>
                {CamelCase(orderStatus[OrderData?.order?.status]) === 'Cancelled' && (
                    <div className="pb-2 mr-2">
                        <p className="text-[#777777] font-semibold text-xs text-center">Order Cancelled By</p>
                        <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{`${OrderData?.order?.order_cancelled_by?.employee_code || ''} - ${OrderData?.order?.order_cancelled_by?.first_name || ''} ${OrderData?.order?.order_cancelled_by?.last_name || ''}`}</p>
                    </div>
                )}
                <div className="pb-2 mr-2">
                    <p className="text-[#777777] font-semibold text-xs">Plant Name</p>
                    <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{OrderData && Object(OrderData?.order).hasOwnProperty('plant_info') && OrderData?.order.plant_info.DESCRIPTION || '-'}</p>
                </div>
                <div className="pb-2 mr-2">
                    <p className="text-[#777777] font-semibold text-xs">Order Created</p>
                    <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{generateDateWithTime(OrderData?.order?.created_at)}</p>
                </div>
                <div className="pb-2 mr-2">
                    <p className="text-[#777777] font-semibold text-xs">Expected Dispatch</p>
                    <p className="font-normal sm:text-lg text-sm text-[#090406] sm:text-center text-start">{getDispatchDate()}</p>
                </div>
            </div>
            <div className="flex">
                <div className="w-[45%] ml-2">
                    <p className="text-xs6 text-[#090406] font-semibold my-3">Order Confirmation</p>
                    <div className="sm:py-2 py-1 px-3 bg-[#F5F5FA] rounded-lg flex justify-between items-center lg:flex-nowrap flex-wrap">
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs">Order Acceptance No.</p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406]">{OrderData?.order?.order_info !== undefined && OrderData?.order?.order_info !== null ? OrderData?.order?.order_info[0].ORDER_NUMBER : '-'}</p>
                        </div>
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs">Order Acceptance Date</p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406]">{OrderData?.order?.order_info !== undefined && OrderData?.order?.order_info !== null ? OrderData.order.order_info[0].ORDER_ACCEPTANCE_DATE : '-'}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
